document.addEventListener("DOMContentLoaded", () => {
  const MAX_CLICK_COUNT = 5;
  let emailPopupCookieName = "";
  if (!!getCookieNameWithEnv)
    emailPopupCookieName = getCookieNameWithEnv(window.location.hostname, "email_popup_counter");
  const emailPopupContainer = document.getElementById("fp-email-capture-popup-container");
  const emailPopupContent = document.getElementById("fp-email-popup-content");
  const emailPopupCloseBtn = document.getElementById("fp-email-popup-close");
  const emailFormEmailInput = document.getElementById("fp-popup-email-address");
  const emailFormErrorMsg = document.getElementById("fp-popup-error");
  const emailFormJoinNowBtn = document.getElementById("fp-popup-join-now-btn");
  const emailPopupThankyou = document.getElementById("fp-email-popup-thank-you");
  const emailFormThankYouCloseBtn = document.getElementById("fp-popup-thankyou-close-btn");
  const emailFormDeclineNewsletter = document.getElementById("fp-email-popup-decline-link");
  const EMAIL_POPUP_INVALID_EMAIL_ERROR = "Please enter a valid email address";
  let emailPopupCounterCookie = Number(getCookie(emailPopupCookieName)) || 0;
  const pathname = window.location.pathname;

  if (!emailPopupCounterCookie) {
    setCookie(emailPopupCookieName, 0, 365); // create cookie for first time
  }

  emailFormJoinNowBtn.addEventListener("click", async (event) => {
    event.preventDefault();
    const userInputValue = emailFormEmailInput?.value.trim() || "";

    if (!EMAIL_VALIDATION_REGEX.test(userInputValue)) {
      emailFormErrorMsg.textContent = EMAIL_POPUP_INVALID_EMAIL_ERROR;
      return;
    }

    setCookie(emailPopupCookieName, MAX_CLICK_COUNT + 1, 365);
    await handleSubscribe();
    emailPopupContent.style.display = "none";
    emailPopupThankyou.style.display = "flex";

    // automatically close thank-you form after 2 seconds
    setTimeout(() => {
      emailPopupContainer.classList.add("hidden--important");
      document.body.style.overflow = "auto";
    }, 2000);
  });

  emailPopupCloseBtn.addEventListener("click", () => {
    if (emailPopupContainer) {
      emailPopupContainer.classList.add("hidden--important");
      document.body.style.overflow = "auto";
      setCookie(emailPopupCookieName, MAX_CLICK_COUNT + 1, 365);
      emailPopupCounterCookie++;
    }
  });

  emailFormThankYouCloseBtn.addEventListener("click", () => {
    if (emailPopupContainer) {
      emailPopupContainer.classList.add("hidden--important");
      document.body.style.overflow = "auto";
      setCookie(emailPopupCookieName, MAX_CLICK_COUNT + 1, 365);
      emailPopupCounterCookie++;
    }
  });

  emailFormDeclineNewsletter.addEventListener("click", () => {
    emailPopupContainer.style.display = "none";
    setCookie(emailPopupCookieName, MAX_CLICK_COUNT + 1, 365);
  });

  function handleShowEmailPopupModal() {
    // Note: a full page reload (manual or nav click) terminates all pending setTimeout operations
    setTimeout(() => {
      emailPopupContainer.classList.remove("hidden--important");
      emailPopupContainer.style.opacity = 0;
      requestAnimationFrame(function () {
        emailPopupContainer.style.transition = "opacity 0.3s";
        emailPopupContainer.style.opacity = 1;
      });
    }, 1000);
  }

  async function handleSubscribe() {
    const emailCaptureForm = document.getElementById("fp-email-popup-form");
    const emailCaptureFormData = new FormData(emailCaptureForm);
    const webAppDomain = emailCaptureFormData.get("web-app-domain");
    const formUserEmail = emailCaptureFormData.get("fp-popup-email-address");

    const payload = new URLSearchParams();
    //   Required Salesforce fields
    payload.append("oid", "00D1N000002r6Jz");
    payload.append("retURL", window.location.origin);

    payload.append("email", formUserEmail);
    payload.append("Subscription_Source__c", "subscribe_page");
    payload.append("Accepts_FP_Newsletter__c", "1");
    payload.append("Accepts_Blog_Updates__c", "1");

    try {
      await fetch(`${webAppDomain}/newsletter/subscribe`, {
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
    } catch (error) {
      console.error("Error signing up", error);
    }
  }

  function bodyClickEmailPopupHandler() {
    if (pathname.includes("/pages/sign-in") || pathname.includes("/pages/sign-up")) {
      return;
    }
    if (emailPopupCounterCookie < MAX_CLICK_COUNT) {
      emailPopupCounterCookie++;
      setCookie(emailPopupCookieName, emailPopupCounterCookie, 365);
    }
    if (emailPopupCounterCookie === MAX_CLICK_COUNT) {
      document.body.style.overflow = "hidden";
      handleShowEmailPopupModal();
      document.body.removeEventListener("click", bodyClickEmailPopupHandler);
    }
  }

  function pageLoadEmailPopupHandler() {
    // necessary so modal is not displayed when user navigates to sign in/up page
    setTimeout(() => {
      if (pathname.includes("/pages/sign-in") || pathname.includes("/pages/sign-up")) {
        return;
      }
      emailPopupCounterCookie = Number(getCookie(emailPopupCookieName)) || 0;
      if (emailPopupCounterCookie === MAX_CLICK_COUNT) {
        document.body.style.overflow = "hidden";
        // ensure modal is displayed after page reload is complete
        handleShowEmailPopupModal();
        window.removeEventListener("load", pageLoadEmailPopupHandler);
      }
    }, 500);
  }

  window.addEventListener("load", pageLoadEmailPopupHandler);
  document.body.addEventListener("click", bodyClickEmailPopupHandler);
});
